<div class="table-responsive" [class.overflow-hidden]="amenitiesService.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover footable">
        <thead>
            <tr [ngClass]="{'noSort': amenitiesService.data.allAmenities.data.length < 2}">
                <th style="width: 50px;"></th>
                <th (click)="orderBy('bookingNumber', $event)">
                    ID#
                    <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('amenity', $event)">
                    Amenity
                    <span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="amenitiesService.buildings.length > 1 && !authenticationService.userIsResident" (click)="orderBy('building.name', $event)">
                    Building
                    <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('suite.suiteNumber', $event)" *ngIf="!authenticationService.userIsResident">
                    Unit
                    <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('resident.fullName', $event)" *ngIf="!authenticationService.userIsResident">
                    Resident
                    <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('dateFrom', $event)">
                    Start Time
                    <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('dateTo', $event)">
                    End Time
                    <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('createdAt', $event)" class="footable-sorted-desc" *ngIf="!authenticationService.userIsResident">
                    Created On
                    <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('createdBy.fullName', $event)">
                    Created By
                    <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('status', $event)">
                    Status
                    <span class="footable-sort-indicator"></span>
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-template ngFor let-item [ngForOf]="amenitiesService.data.allAmenities.data" let-index="index">
                <tr [ngClass]="{'footable-odd': (index % 2 === 0)}" (click)="$event.showDropdown || toggleCheck(item)">
                    <td>
                        <label class="img-checkbox">
                            <input type="checkbox" [ngModel]="item.checked">
                            <label><svg-checked></svg-checked></label>
                        </label>
                    </td>
                    <td class="item-of-list">
                        <div class="table-mobile-left">
                            <span>ID#</span>
                        </div>
                        <span>{{item.bookingNumber}}</span>
                    </td>
                    <td class="item-of-list">
                        <div class="table-mobile-left">
                            <span>Amenity</span>
                        </div>
                        <span>{{item.amenityName}}</span>
                    </td>
                    <td class="item-of-list" *ngIf="amenitiesService.buildings.length > 1 &&
                                                    !authenticationService.userIsResident">
                        <div class="table-mobile-left">
                            <span>Building</span>
                        </div>
                        <span>{{item.buildingName}}</span>
                    </td>
                    <td class="item-of-list" *ngIf="!authenticationService.userIsResident">
                        <div class="table-mobile-left">
                            <span>Unit</span>
                        </div>
                        <span>{{item.suiteNumber}}</span>
                    </td>
                    <td class="item-of-list" *ngIf="!authenticationService.userIsResident">
                        <div class="table-mobile-left">
                            <span>Resident</span>
                        </div>
                        <span>{{item.residentFullName}}</span>
                    </td>
                    <td class="item-of-list">
                        <div class="table-mobile-left">
                            <span>Start Time</span>
                        </div>
                        <span>{{item.dateFrom | date:'dd.MM.yyyy hh:mm a':'+0000'}}</span>
                    </td>
                    <td class="item-of-list">
                        <div class="table-mobile-left">
                            <span>End Time</span>
                        </div>
                        <span>{{item.dateTo | date:'dd.MM.yyyy hh:mm a':'+0000'}}</span>
                    </td>
                    <td *ngIf="!authenticationService.userIsResident" class="item-of-list">
                        <div class="table-mobile-left">
                            <span>Created On</span>
                        </div>
                        <span>{{item.createdAt | date:'dd.MM.yyyy hh:mm a'}}</span>
                    </td>
                    <td class="item-of-list">
                        <div class="table-mobile-left">
                            <span>Created By</span>
                        </div>
                        <span>{{item.createdBy}}</span>
                    </td>
                    <td class="item-of-list">
                        <div class="table-mobile-left">
                            <span>Status</span>
                        </div>
                        <div class="table-mobile-right">
                            <span *ngIf="item.status === 'approved'" class="label label-approved">Approved</span>
                            <span *ngIf="item.status === 'pending'" class="label label-pending">Pending</span>
                            <span *ngIf="item.status === 'expired'" class="label label-expired">Expired</span>
                            <span *ngIf="item.status === 'declined'" class="label label-declined">Declined</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <tr *ngFor="let item of amenitiesService.emptyRowService.emptyRow" class="empty-row" style="cursor: default;">
                <td></td>
                <td>&nbsp;</td>
                <td *ngIf="amenitiesService.buildings.length > 1"></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </tbody>
    </table>

    <empty-result-message
            [isEmpty]="!amenitiesService.data.allAmenities.total"
            [isServiceUnavailable]="amenitiesService.showServiceUnavailable"
            [isLoading]="amenitiesService.spinnerShow && amenitiesService.view == 'list'">
        You do not have any bookings yet<br>
        <span *ngIf="amenitiesService.canEdit() && (!authenticationService.userIsResident || (authenticationService.userIsResident && amenitiesService.amenitiesByBuilding.length > 0)) && (amenitiesService.buildings.length || residentService.buildings.length)">
            <a href="javascript://" (click)="amenitiesService.isAmenityModalShow = true" class="mtv-primary-color clickable-text">book amenity</a> now
        </span>
    </empty-result-message>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenities-list/amenities-list.component.html